<template>
  <section >
    <button class="btn w-100 p-0 btn-whole-add btn-whole-add-dashed"
            :disabled="loading"
            @click="addStudentLight">
      <span class="svg-wrapper mr-3">
        <PlusSvg class="svg-icon-sm"/>
      </span>
      {{ $t('add_material') }}
    </button>
    <SelectLightCourseMaterial :select-course="true"
                               @courseSelected="courseSelected"/>
    <div v-for="s in student.lightCourses.data"
         class="stud-history-teaser"
         :key="`light-course-${s.id}`">
      <b-row class="align-items-center">
        <b-col md cols="12">
          <div v-if="s.light_course">{{ s.light_course.title }}</div>
<!--          <div class="mt-2" v-if="d.finished || d.reviewed">-->
<!--            <span v-if="d.finished" class="done-span mr-2">{{ $t('done') }}</span>-->
<!--            <span v-if="d.reviewed" class="reviewed-span">{{ $t('reviewed') }}</span>-->
<!--          </div>-->
        </b-col>
        <b-col lg="auto" cols="6" class="text-right">
          <b-dropdown right no-caret menu-class="noscrollbar" variant="btn" class="">
            <template v-slot:button-content>
              <a class=" btn-themed btn-white btn-sm pointer">
                <MoreSvg class="d-inline-block"/>
              </a>
            </template>
            <b-dropdown-item @click="removeLight(s.lightcourse_id)" >
              <TrashSvg class="svg-black mr-2"/>{{ $t('delete') }}
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
import PlusSvg from '@/assets/svg/plus.svg'
import MoreSvg from "@/assets/svg/dots.svg"
import TrashSvg from '@/assets/svg/trash.svg'
import SelectLightCourseMaterial from "@/views/parts/class/SelectLightCourseMaterial.vue"
import { StudentsService } from "../../../../../services/api.service"

export default {
  components: {
    SelectLightCourseMaterial,
    PlusSvg,
    MoreSvg,
    TrashSvg
  },
  data() {
    return {
      loading: false
    }
  },
  props: {
    student: {}
  },
  methods: {
    addStudentLight() {
      this.$bvModal.show('selectLightCourseMaterial')
    },
    courseSelected(course) {
      this.loading = true
      StudentsService.addLightToStudent(this.student.id, course.id).then(res => {
        this.student.lightCourses = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    removeLight(lightCourseId) {
      this.loading = true
      StudentsService.removeLightFromStudent(this.student.id, lightCourseId).then(res => {
        this.student.lightCourses = res.data
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.stud-history-teaser {
  padding: 24px 0;
  border-bottom: 1px solid $border-gray;
  font-size: 16px;
}
.svg-black {
  width: 20px;
  height: 20px;
}
@media(max-width: 768px) {
  .stud-history-teaser {
    font-size: 14px;
  }
}
</style>


